import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const CircleConfirmIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="check-circle" {...props} />;
};

export { CircleConfirmIcon };
